import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import Layout from "../../../component/Layout/Layout"
import Card from "../../../component/Layout/theme/card";
import PageChange from "../../../component/pageChange";

function Preview() {
    var { t } = useTranslation()
    const { login, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);



    useEffect(() => {
        document.title = "پیش نمایش"
        if (!login) {
            window.location.href = '/auth'
        }
        setIsDataLoad(true)
    }, [])



    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (

                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md h-[700px]">
                    </div >
                ) : (
                    <PageChange />
                )}

            </Card >

        </>
    )
}

export default Preview